import React from 'react';
import DataTable from 'react-data-table-component';
import DataTableFilter from "./data-table-filter";
import Loading from "../loading";
import {useAuthService} from "../../services/auth-service";

export default function DataTableBase( {columns, data, ...props} ){
  const filterKey = '--filter-key'
  const [filterText, setFilterText] = React.useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const paginationComponentOptions = {
    rowsPerPageText: 'počet riadkov na stranu',
    rangeSeparatorText: 'z',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Všetky',
  };

  const authService = useAuthService();

  const paginationRowsPerPage = authService.hasRole('admin') ? 50 : 10;

  const extendedColumns = React.useMemo(() => {
    if (!columns){
      return [];
    }
    return columns.map((col)=>{
      col.sortable = col.hasOwnProperty('sortable') ? col.sortable : true;
      col.reorder = col.hasOwnProperty('reorder') ? col.reorder : true;
      col.filter = col.hasOwnProperty('filter') ? col.filter : true;
      return col;
    })
  }, [columns]);

  const extendedData = React.useMemo(() => {
    if (
      !extendedColumns || !extendedColumns.length
      || !data || !data.length
    ){
      return data;
    }
    return data.map((item)=>{
      item[filterKey] = [];
      extendedColumns.map((col)=>{
        if (col.filter && !col.button && col.hasOwnProperty('selector') && col.selector(item)){
          try{
            //toto moze byt string, number, array, jsx objekt...
            let filterVal = col.hasOwnProperty('filterSelector') && col.filterSelector(item)
              ? col.filterSelector(item).toString().toLowerCase()
              : col.selector(item).toString().toLowerCase()
            item[filterKey].push(filterVal);
          } catch (e){}
        }
      })
      item[filterKey] = item[filterKey].length ? item[filterKey].join('--') : '';
      return item;
    })
  }, [data, extendedColumns]);

  const filteredItems = React.useMemo(() => {
    if (!filterText){
      return extendedData;
    }
    let filterWords = filterText.toLowerCase().split(' ');
    filterWords = typeof filterWords === 'string' ?  [filterWords] : filterWords;
    let filterLen = filterWords.length;

    return extendedData.filter(
      item => {
        if (!item || !item[filterKey]){
          return false;
        }
        let matches = filterWords.filter((filterWord)=>{
          return item[filterKey].includes(filterWord);
        });
        return matches && matches.length >= filterLen;
      }
    )
  }, [filterText, extendedData, extendedColumns]);

  const filterComponent = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
    };
    return (
      <DataTableFilter onFilter={(e)=>setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <>
      {filterComponent}
      <DataTable
        columns={extendedColumns}
        data={filteredItems}
        noDataComponent={(<div className="my-3 text-muted text-center">Nenašli sme záznamy, ktoré by sme vedeli zobraziť.</div>)}
        pagination
        paginationComponentOptions={paginationComponentOptions}
        paginationResetDefaultPage={resetPaginationToggle}
        paginationPerPage={paginationRowsPerPage}
        paginationRowsPerPageOptions={[10,20,50,100]}
        persistTableHead
        highlightOnHover={!!props.onRowClicked}
        pointerOnHover={!!props.onRowClicked}
        onRowClicked={(row,e)=>{props.onRowClicked ? props.onRowClicked(row, e) : null}}
        progressComponent={<Loading className="m-2" />}
        {...props}
      />
    </>
  );
}
